<section class="page">
  <header class="page-header">
    <div>
      <h1>Subscriptions</h1>
      <p>Manage plan catalog (membership card CMS) and user subscriptions</p>
    </div>
  </header>

  <div class="tabs">
    <button
      type="button"
      class="tab"
      [class.active]="tab() === 'plans'"
      (click)="setTab('plans')"
    >
      Plans
    </button>
    <button
      type="button"
      class="tab"
      [class.active]="tab() === 'users'"
      (click)="setTab('users')"
    >
      User subscriptions
    </button>
  </div>

  @if (error()) {
    <div class="alert alert-error">{{ error() }}</div>
  }
  @if (success()) {
    <div class="alert alert-success">{{ success() }}</div>
  }

  @if (tab() === 'plans') {
    @if (editingPlanId()) {
      <div class="panel create-panel">
        <h2>Edit plan #{{ editingPlanId() }}</h2>
        <form [formGroup]="planForm" (ngSubmit)="savePlan()" class="create-form">
          <label>
            <span>Name</span>
            <input type="text" formControlName="name" />
          </label>
          <label>
            <span>Card title</span>
            <input type="text" formControlName="card_title" placeholder="Shown on membership card" />
          </label>
          <label>
            <span>Card label</span>
            <input type="text" formControlName="card_label" placeholder="MEMBERSHIP" />
          </label>
          <label>
            <span>Price</span>
            <input type="number" step="0.01" formControlName="price" />
          </label>
          <label>
            <span>Currency</span>
            <input type="text" formControlName="currency" />
          </label>
          <label>
            <span>Currency symbol</span>
            <input type="text" formControlName="currency_symbol" placeholder="$" />
          </label>
          <label>
            <span>Interval</span>
            <input type="text" formControlName="billing_interval" placeholder="month" />
          </label>
          <label>
            <span>Billing label</span>
            <input type="text" formControlName="billing_label" placeholder="/ month" />
          </label>
          <label>
            <span>Rent points</span>
            <input type="number" formControlName="rent_points" placeholder="500" />
          </label>
          <label>
            <span>Reward multiplier</span>
            <input type="number" formControlName="reward_multiplier" />
          </label>
          <label>
            <span>Sort order</span>
            <input type="number" formControlName="sort_order" />
          </label>
          <label>
            <span>Stripe product ID</span>
            <input type="text" formControlName="stripe_product_id" />
          </label>
          <label>
            <span>Stripe price ID</span>
            <input type="text" formControlName="stripe_price_id" />
          </label>
          <label class="full">
            <span>Tagline</span>
            <input type="text" formControlName="tagline" placeholder="Make more of your membership." />
          </label>
          <label class="full">
            <span>Card image URL</span>
            <input type="text" formControlName="card_image_url" placeholder="https://…" />
          </label>
          <label class="full">
            <span>Description</span>
            <input type="text" formControlName="description" />
          </label>
          <label>
            <span>Compare link text</span>
            <input type="text" formControlName="comparison_link_text" />
          </label>
          <label>
            <span>Primary button text</span>
            <input type="text" formControlName="primary_button_text" />
          </label>

          <div class="full benefits-block">
            <div class="benefits-header">
              <h3>Benefits (mobile list)</h3>
              <button class="btn btn-secondary btn-sm" type="button" (click)="addBenefit()">
                Add benefit
              </button>
            </div>
            <div formArrayName="benefits" class="benefits-list">
              @for (ctrl of benefits.controls; track $index; let i = $index) {
                <div class="benefit-row" [formGroupName]="i">
                  <label>
                    <span>Title</span>
                    <input type="text" formControlName="title" placeholder="500 points for paying rent" />
                  </label>
                  <label>
                    <span>Key</span>
                    <input type="text" formControlName="key" placeholder="rent_points" />
                  </label>
                  <label>
                    <span>Icon URL</span>
                    <input type="text" formControlName="icon_url" placeholder="https://…" />
                  </label>
                  <label>
                    <span>Sort</span>
                    <input type="number" formControlName="sort_order" />
                  </label>
                  <label class="full">
                    <span>Description</span>
                    <input type="text" formControlName="description" placeholder="Optional subtext" />
                  </label>
                  <label class="full">
                    <span>Detail URL</span>
                    <input type="text" formControlName="detail_url" placeholder="Optional deep link" />
                  </label>
                  <label class="checkbox">
                    <input type="checkbox" formControlName="is_clickable" />
                    <span>Clickable</span>
                  </label>
                  <button class="btn btn-secondary btn-sm" type="button" (click)="removeBenefit(i)">
                    Remove
                  </button>
                </div>
              } @empty {
                <p class="muted">No benefits yet — add rows for the membership card list.</p>
              }
            </div>
          </div>

          <label class="checkbox"><input type="checkbox" formControlName="member_offers" /><span>Member offers</span></label>
          <label class="checkbox"><input type="checkbox" formControlName="ai_assistant" /><span>AI assistant</span></label>
          <label class="checkbox"><input type="checkbox" formControlName="smart_insights" /><span>Smart insights</span></label>
          <label class="checkbox"><input type="checkbox" formControlName="priority_support" /><span>Priority support</span></label>
          <label class="checkbox"><input type="checkbox" formControlName="concierge_support" /><span>Concierge</span></label>
          <label class="checkbox"><input type="checkbox" formControlName="airport_lounge_access" /><span>Airport lounge</span></label>
          <label class="checkbox"><input type="checkbox" formControlName="travel_perks" /><span>Travel perks</span></label>
          <label class="checkbox"><input type="checkbox" formControlName="is_active" /><span>Active</span></label>
          <div class="actions">
            <button class="btn btn-primary" type="submit" [disabled]="saving()">
              {{ saving() ? 'Saving…' : 'Save' }}
            </button>
            <button class="btn btn-secondary" type="button" (click)="cancelEdit()" [disabled]="saving()">
              Cancel
            </button>
          </div>
        </form>
      </div>
    }

    <div class="panel">
      <div class="table-wrap">
        <table>
          <thead>
            <tr>
              <th>Key</th>
              <th>Name</th>
              <th>Price</th>
              <th>Rent pts</th>
              <th>Benefits</th>
              <th>Active</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            @if (loading()) {
              <tr><td colspan="7" class="muted">Loading…</td></tr>
            } @else if (!plans().length) {
              <tr><td colspan="7" class="muted">No plans</td></tr>
            } @else {
              @for (plan of plans(); track plan.id) {
                <tr>
                  <td class="mono">{{ plan.plan_key }}</td>
                  <td>{{ plan.name }}</td>
                  <td>{{ plan.currency_symbol || '$' }}{{ plan.price }} {{ plan.billing_label || '' }}</td>
                  <td>{{ plan.rent_points ?? '—' }}</td>
                  <td>{{ benefitCount(plan) }}</td>
                  <td>{{ plan.is_active ? 'Yes' : 'No' }}</td>
                  <td>
                    <button class="btn btn-secondary btn-sm" type="button" (click)="editPlan(plan)">
                      Edit
                    </button>
                  </td>
                </tr>
              }
            }
          </tbody>
        </table>
      </div>
    </div>
  } @else {
    <div class="page-header inline">
      <div></div>
      <button class="btn btn-primary" type="button" (click)="openGrant()">Grant subscription</button>
    </div>

    @if (showGrant()) {
      <div class="panel create-panel">
        <h2>Grant subscription</h2>
        <form [formGroup]="grantForm" (ngSubmit)="grant()" class="create-form">
          <label>
            <span>User ID</span>
            <input type="number" formControlName="user_id" />
          </label>
          <label>
            <span>Plan</span>
            <select formControlName="plan_key">
              <option value="essential">Essential</option>
              <option value="student">Student</option>
              <option value="plus">Plus</option>
              <option value="black">Black</option>
            </select>
          </label>
          <div class="actions">
            <button class="btn btn-primary" type="submit" [disabled]="saving()">Grant</button>
            <button class="btn btn-secondary" type="button" (click)="cancelGrant()">Cancel</button>
          </div>
        </form>
      </div>
    }

    <div class="panel">
      <div class="table-wrap">
        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>User</th>
              <th>Plan</th>
              <th>Status</th>
              <th>Provider</th>
              <th>Period end</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            @if (loading()) {
              <tr><td colspan="7" class="muted">Loading…</td></tr>
            } @else if (!subs().length) {
              <tr><td colspan="7" class="muted">No subscriptions</td></tr>
            } @else {
              @for (row of subs(); track row.id) {
                <tr>
                  <td>{{ row.id }}</td>
                  <td>
                    #{{ row.user_id }}
                    @if (row.user?.email) {
                      <div class="muted small">{{ row.user?.email }}</div>
                    }
                  </td>
                  <td>{{ row.plan_key }}</td>
                  <td><span class="badge" [attr.data-status]="row.status">{{ row.status }}</span></td>
                  <td>{{ row.provider || '—' }}</td>
                  <td>{{ row.current_period_end ? (row.current_period_end | date: 'mediumDate') : '—' }}</td>
                  <td class="row-actions">
                    <button class="btn btn-secondary btn-sm" type="button" (click)="cancelSub(row, false)" [disabled]="saving()">
                      Cancel EoP
                    </button>
                    <button class="btn btn-secondary btn-sm" type="button" (click)="cancelSub(row, true)" [disabled]="saving()">
                      Cancel now
                    </button>
                    <button class="btn btn-secondary btn-sm" type="button" (click)="deleteSub(row)" [disabled]="saving()">
                      Delete
                    </button>
                  </td>
                </tr>
              }
            }
          </tbody>
        </table>
      </div>
      @if (totalPages() > 1) {
        <div class="pager">
          <button type="button" class="btn btn-secondary btn-sm" [disabled]="page() <= 1" (click)="loadSubs(page() - 1)">
            Prev
          </button>
          <span class="muted">Page {{ page() }} / {{ totalPages() }}</span>
          <button
            type="button"
            class="btn btn-secondary btn-sm"
            [disabled]="page() >= totalPages()"
            (click)="loadSubs(page() + 1)"
          >
            Next
          </button>
        </div>
      }
    </div>
  }
</section>
